import React from 'react';


const PanelEnd = React.memo( function PanelEnd() {
  return <></>;
} );

export default PanelEnd;
